<template>
    <div>
        <div class="box">
            <p class="return" @click="back">返回首页</p>
            <span class="line">|</span>
            <p class="contract">系统设置</p>
            <span class="lines">></span>
            <p class="contract back" @click="$router.go(-1)" v-if="$route.query.flag && $route.query.flag==7">组织管理</p>
             <p class="contract back" @click="$router.go(-1)" v-else>账号管理</p>
            <span class="lines">></span>
            <p class="contract">编辑权限</p>
        </div>
        <div class="p_btn" >
            <div>
                <div class="mainTitle" v-if="!edit">创建账号</div>
                <div class="mainTitle" v-if="edit">编辑权限</div>

            </div>
        </div>
        <div class="dataitems" v-if="edit">
            <el-form label-width="100px" ref="editInfo" :rules="rules" :model="editInfo" label-position="right">
                <div class="item">
                    <el-form-item label="姓名：">
                        {{editInfo.name}}
                    </el-form-item>
                    <!-- <el-form-item label="手机号：">
                        {{editInfo.mobile}}
                    </el-form-item>
                    <el-form-item label="邮箱：">
                        {{editInfo.email}}
                    </el-form-item> -->
                    <!-- <el-form-item label="部门" prop="orgId">
                        <el-select v-model="editInfo.orgId" placeholder="请选择">
                            <el-option :label="v.name" :value="v.id" v-for="(v,k) in orgList" :key="k"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="权限：">
                        <el-radio-group v-model="editInfo.authority">
                            <el-radio :label="true">选择权限组</el-radio>
                            <el-radio :label="false">直接设置权限</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="editInfo.authority==true" label="权限组" haveto="true" prop="accountGroup">
                        <el-select v-model="editInfo.accountGroup" placeholder="请选择权限组">
                            <el-option :label="v.name" :value="v.id" v-for="(v,k) in accountGroup" :key="k"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </el-form>
        </div>
    <!-- <div v-if="editInfo.authority==false||baseInfo.authority==false" class="contree">
            <div class="trees">
                <div class="table">
                    <h4>页面权限</h4>
                </div>

                <div class='mytree'>
                    <div class='first'>嗖嗖人力服务平台</div>

                    <el-tree
                            ref="treed"
                            :default-checked-keys="defaultLists"
                            :default-expanded-keys="defaultLists"
                            :props="propsa"
                            :data="data"
                            :indent='0'
                            node-key="id"
                            @check="checkAllTree"
                            show-checkbox
                            @node-click="handleCheckon"
                            @check-change="handleCheckChange">
              <span class="custom-tree-node" slot-scope="{node,data}">
                 <span>
              <i v-if='data.type==1'>
	        <img src="../../../assets/img/shezhi.png"></img>
                
              </i>
               <i v-if='data.type==2'>
	        <img src="../../../assets/img/shezhi1.png"></img>
                
              </i>
            
            {{data.name}}
                 </span>              
           </span>
                    </el-tree>

                </div>

            </div>
            <div class="edit">
                <div class="table">
                    <h4>操作权限</h4>
                </div>
                <div class="edut">
                    <div class="fontName">{{operationName}}</div>
                    <el-checkbox-group v-model="checkOne" class="checkGroup">
                        <el-checkbox v-for="(v,k) in operation"
                                     :label="v.id"
                                     :key="k"
                                     :disabled = v.disabled
                                     @change="handleCheckedCitiesChange($event,v.id,checkOne)">
                            {{v.name}}
                        </el-checkbox>
                    </el-checkbox-group>
                </div>


            </div>

        </div> -->
        <!-- <div class="btndiv">
            <button class="btn" type="button" @click='$router.go(-1)' tag="button">取消</button>
            <button class="btn subbtn" @click="addOrg" type="button">保存</button>
        </div> -->
        <div class="ibox" v-if="editInfo.authority==false">
            <div class="table">
              <h4 style="font-weight:bold;color:rgba(48,49,64,1);">权限设置</h4>
              <div class="operating"></div>
            </div>
            <div role="tablist" aria-multiselectable="true" class="el-collapse">
              <div class="ssg_title">
                <span style="margin-right: 75px;">功能模块</span>
                <span>页面查看权限</span>
                <span>页面功能权限</span>
              </div>
              <permissionList :treeData="treeData"/>
            </div>
        </div>
        <div class="btndiv">
          <button class="btn" tag="button" @click="$router.go(-1)">取消</button>
          <button class="btn subbtn" @click="headSwitch">保存</button>
        </div>

    </div>
</template>

<script>
import permissionList from '../setPower/permissionList.vue'
export default {
  components: {
    permissionList
  },
  created() {
    this.edit = this.$route.query.edit;
    //初始化数据
    this.loadData();
    this.loadDataPandO();
    this.loadaddCount();
    if (this.$route.query.id) {
      this.loadEiditPermission();
    }
  },
  data() {
    return {
      operationIds: [],
      singleIds: [],
      checkIdTrees: "",
      checkk: [],
      detailList: [],
      chonse: false,
      codes: "",
      checks: false,
      listidss: [],
      choseYes: false,
      defaultLists: [],
      listIds: [],
      actionid: "",
      operationName: "",
      permissionList: [],
      operation: [],
      checkOne: [],
      data: [],
      editInfo: {},
      propsa: {
        label: "name",
        value: "id",
        children: "children",
      },
      props: {
        label: "label",
        value: "id",
        children: "children",
      },
      edit: false,
      orgList: [],
      baseInfo: {
        name: "",
        mobile: "",
        email: "",
        orgId: "",
        authority: true,
        accountGroup: "",
      },
      accountGroup: [],
      rules: {
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱",
            trigger: "blur",
          },
        ],
        orgId: [
          {
            required: true,
            message: "请选择部门",
            trigger: "change",
          },
        ],
        accountGroup: [
          {
            required: true,
            message: "请选择权限组",
            trigger: "change",
          },
        ],
      },



      permissionList: [],
      list_openStatus: [],
      form: {
        values: [],
      },
      treeData:[],
      perData:[],
  
    };
  },
  watch: {
    permissionList(val) {
      for (var i = 0; i < val.length; i++) {
        this.list_openStatus.push(false);
      }
    },
  },
  methods: {
    back() {
      this.$router.push({ path: "/main" });
    },
    checkAllTree(data, list) {
      this.checkIdTrees = data.id;
      this.choseYes = true;
      // this.listIds = list.checkedNodes

      let parentArr = this.$refs.treed.getHalfCheckedKeys();
      let childeArr = this.$refs.treed.getCheckedKeys();
      let arr = childeArr.concat(parentArr);

      this.listIds = arr;
    },

    detailTrees(data, values) {
      // let detailList = []
      for (var key in data) {
        if (data[key].children.length > 0) {
          this.detailTrees(data[key].children, values);
        } else {
          this.detailList.push(data[key].id);
        }
      }
      let arr = [];

      for (let j of this.detailList) {
        for (let i of values) {
          if (i == j) {
            arr.push(+i);
          }
        }
      }
      this.permissionList = values;
      this.defaultLists = arr;
    },

    loadEiditPermission() {
      const params = {
        userId: this.$route.query.id,
      };
      this.$axios
        .get("/userInfo/queryUserInfo", {
          params,
        })
        .then((res) => {
          if (res.data.status == 1) {
           
            if (res.data.data.permissionGroupId) {
              this.$nextTick(() => {
                this.$set(this.editInfo, "authority", true);
              });
            } else{
              this.$nextTick(() => {
                this.$set(this.editInfo, "authority", false);
              });
            }
            this.editInfo = {
              mobile: res.data.data.mobile,
              name: res.data.data.name,
              email: res.data.data.email,
              orgId: res.data.data.orgId,
              authority: this.editInfo.authority,
              accountGroup: res.data.data.permissionGroupId,
            };
          }
        });
    },

    //保存

    addOrg() {
      this.listidss = [];

      if (this.edit) {
        this.$refs.editInfo.validate((status) => {
          if (status == true) {
            if (this.editInfo.authority == false) {
              this.editInfo.accountGroup = "";
              if (this.choseYes == true || this.checks == true) {
                let parentArr = this.$refs.treed.getHalfCheckedKeys();
                let childeArr = this.$refs.treed.getCheckedKeys();
                let arr = childeArr.concat(parentArr);
                this.listIds = arr;
                if (this.listIds.length > 0) {
                  for (let i of this.listIds) {
                    this.listidss.push(i);
                  }
                } else if (this.listIds.length == 0) {
                  this.listidss == [];
                } else {
                  for (let i of this.defaultLists.values()) {
                    this.listidss.push(i);
                  }
                }
                for (let j of this.checkOne.values()) {
                  this.listidss.push(j);
                }
              } else {
                this.listidss = this.permissionList;
              }
            } else if (this.editInfo.authority == true) {
              this.listidss = [];
            }
            this.$axios
              .post(
                "userInfo/updateServerPermission?permissionList=" +
                  this.listidss +
                  "&permissionGroupId=" +
                  this.editInfo.accountGroup +
                  "&userId=" +
                  this.$route.query.id
              )
              .then((res) => {
                if (res.data.status == 1) {
                  this.$message.success(res.data.message);
                  this.$router.push({ path: "/main/system/system/account" });
                } else {
                  this.$message.error(res.data.message);
                }
              })
              .catch((err) => {
                //处理错误
                this.maskshow = false;
                console.log(err);
              });
          }
        });
      }
    },

    loadaddCount() {
      this.$axios
        .get("/permissionGroup/findPermissionGroups")
        .then((res) => {
          if (res.data.status === 1) {
            this.accountGroup = res.data.data;
          } else {
            this.$message.error("查询权限组请求失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    handleCheckChange(data, checked, indeterminate) {
    },
    handleNodeClick(data) {
    },
    handleCheckedCitiesChange(data, id, ids) {

      if (ids == this.operationIds) {
        this.chonse = true;
      } else {
        this.chonse = false;
      }
    },
    handleCheckon(data) {
      this.operationName = data.name;
      this.checks = true;
      //查询某一个权限
      this.$axios
        .get("/permission/findByParentId?parentId=" + data.id + "&type=" + 0)
        .then((res) => {
          if (res.data.status === 1) {
            this.operation = res.data.data;

            this.operationIds = [];
            for (var i = 0; i < this.operation.length; i++) {
              this.operationIds.push(this.operation[i].id);
            }

            for (var i = 0; i < this.permissionList.length; i++) {
              for (var j = 0; j < this.operation.length; j++) {
                if (this.permissionList[i] == this.operation[j].id) {
                  this.checkk = [];
                  this.checkk.push(this.permissionList[i]);
                  this.checkOne.push(+this.permissionList[i]);
                }
              }
            }
          } else {
            this.$message.error("查询组织列表请求失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    loadDataPandO() {
      //查询组织列表
      this.$axios
        .get("/org/getOrgList")
        .then((res) => {
          if (res.data.status === 1) {
            this.orgList = res.data.data;
          } else {
            this.$message.error("查询组织列表请求失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    change(item) {
      let checked = item.switched;
      if (checked) {
        this.form.values.push(item.id);
        if (item.views && item.views.length > 0) {
          item.views.forEach((element) => {
            element.switched = true;
            this.form.values.push(element.id);
            if (element.funcs.length > 0) {
              element.funcs.forEach((func) => {
                this.form.values.push(func.id);
              });
            }
            if (element.views && element.views.length > 0) {
              element.views.forEach((view) => {
                view.switched = true;
                this.form.values.push(view.id);
                if (view.funcs.length > 0) {
                  view.funcs.forEach((func) => {
                    this.form.values.push(func.id);
                  });
                }
              });
            }
          });
        }
        if (item.funcs.length > 0) {
          item.funcs.forEach((func) => {
            this.form.values.push(func.id);
          });
        }
      } else {
        this.form.values.splice(
          this.form.values.findIndex((v) => v == item.id),
          1
        );
        if (item.views && item.views.length > 0) {
          item.views.forEach((element) => {
            if (element.funcs.length > 0 && element.switched) {
              element.funcs.forEach((func) => {
                if (this.form.values.findIndex((v) => v == func.id) != -1) {
                  this.form.values.splice(
                    this.form.values.findIndex((v) => v == func.id),
                    1
                  );
                }
              });
              this.form.values.splice(
                this.form.values.findIndex((v) => v == element.id),
                1
              );
            }
            element.switched = false;
            if (element.views && element.views.length > 0) {
              element.views.forEach((view) => {
                if (view.funcs.length > 0 && view.switched) {
                  view.funcs.forEach((func) => {
                    if (this.form.values.findIndex((v) => v == func.id) != -1) {
                      this.form.values.splice(
                        this.form.values.findIndex((v) => v == func.id),
                        1
                      );
                    }
                  });
                  this.form.values.splice(
                    this.form.values.findIndex((v) => v == view.id),
                    1
                  );
                }
                view.switched = false;
              });
            }
          });
        }
        if (item.funcs.length > 0) {
          item.funcs.forEach((func) => {
            if (this.form.values.findIndex((v) => v == func.id) != -1) {
              this.form.values.splice(
                this.form.values.findIndex((v) => v == func.id),
                1
              );
            }
          });
        }
      }
    },
    
    open_list(index) {
    
      this.list_openStatus[index] = !this.list_openStatus[index];
      this.$forceUpdate();
    },

    


    // 加载树列表
    loadData() {
      this.$axios
        .get("permission/getEditPermissionTree?id="+this.$route.query.id+"&type=1")
        .then((res) => {
          this.treeData = res.data.data;
        })
        .catch((err) => {
          //处理错误
          console.log(err);
        });
    },
    headSwitch() {
   
      this.perData = [];
      this.treeData.map(item=>{
        if(item.switched) {
          this.perData.push(item.id);
          if(item.views.length > 0) {
              this.recursion(item.views);
          }
          if(item.funcsId.length > 0) {
            this.perData.push(...item.funcsId);
          }
       
         
        }
      })
    
      this.saveData();
    },
    recursion(datas) {
      if(datas) {
        datas.map(item=>{
          if(item.switched) {
            this.perData.push(item.id);
            if(item.views.length > 0) {
            this.recursion(item.views);
          }
          if(item.funcsId.length > 0) {
            this.perData.push(...item.funcsId);
          }
       
          }
        })
      }
    },
    saveData() {
      this.$refs.editInfo.validate((status) => {
          if (status == true) {
            if (this.editInfo.authority == false) {
              this.editInfo.accountGroup = "";
            } else if (this.editInfo.authority == true) {
              this.perData = [];
            }
            this.$axios
                  .post(
                    "userInfo/updateServerPermission?permissionList=" +
                      this.perData +
                      "&permissionGroupId=" +
                      this.editInfo.accountGroup +
                      "&userId=" +
                      this.$route.query.id
                  )
                  .then((res) => {
                    if (res.data.status == 1) {
                      this.$message.success(res.data.message);
                      if(this.$route.query.flag && this.$route.query.flag== 8){
                  this.$router.push({ path: "/main/system/system/orgManage" });

                  }else {
                    this.$router.push({ path: "/main/system/system/account" });

                  }
                    } else {
                      this.$message.error(res.data.message);
                    }
                  })
                  .catch((err) => {
                    //处理错误
                    this.maskshow = false;
                    console.log(err);
                  });

          }
        });
      
      
    },
    
            
  },
};
</script>

<style src="../../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../../assets/css/common/table.less" scoped lang="less"></style>
<style scoped lang="less">
.box {
  display: flex;
  margin-top: 20px;

  .return {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    margin-right: 20px;
    cursor: pointer;
  }

  .line {
    margin-right: 20px;
    color: #606266;
  }

  .lines {
    margin-right: 20px;
    color: #606266;
    font-weight: bold;
  }

  .back:hover {
    color: #6669e3;
    cursor: pointer;
  }

  .contract {
    margin-right: 20px;

    font-size: 12px;
    font-weight: 400;
    color: rgba(138, 138, 154, 1);
  }
}

.mainTitle {
  font-size: 24px;
  font-weight: bold;
  color: rgba(48, 49, 64, 1);
  margin: 33px 0 14px 0;
}

.dataitems {
  width: 55%;
  // padding-left: 12%;
}

.contree {
  width: 100%;
  height: 740px;
  border-radius: 4px;
  border: 1px solid rgba(216, 218, 225, 1);
  display: flex;
}

.trees {
  width: 50%;
  height: 700px;
  overflow-y: auto;
  overflow-x: hidden;

  border-right: 1px solid #d8dae1;
}

.edit {
  width: 50%;
  height: 740px;
  background: rgba(247, 248, 252, 1);
}

.table {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 20px 34px 34px 0;

  h4 {
    font-size: 14px;
    font-weight: bold;
    position: relative;
    display: flex;
    align-items: center;
    padding-left: 8px;
    color: #303140;
  }

  h4:before {
    content: "";
    position: absolute;
    left: 0;
    display: block;
    width: 4px;
    height: 12px;
    background-color: #6669e3;
    border-radius: 4px;
  }
}

.gettree {
  margin-left: 34px;
}

.btndiv {
  display: flex;
  justify-content: center;
  margin: 20px 0;

  .subbtn {
    margin-left: 10px;
  }
}

.mytree {
  margin-left: 40px;

  .first {
    margin-left: 10px;
    font-size: 12px;
    font-weight: bold;
    color: rgba(84, 85, 102, 1);
  }
}

.mytree /deep/ .el-tree {
  > .is-current:after {
    background-color: transparent;
  }

  .el-tree > .is-current:after {
    background-color: transparent;
  }

  .el-tree > .el-tree-node:after {
    border-top: none;
    background-color: #eee;
  }

  .el-tree-node {
    position: relative;
    padding-left: 16px;
  }

  //节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉
  .el-tree-node__expand-icon.is-leaf {
    display: none;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node :last-child:before {
    height: 38px;
  }

  .el-tree > .el-tree-node:before {
    border-left: none;
  }

  .el-tree > .el-tree-node:after {
    border-top: none;
  }

  .el-tree-node:before {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  .el-tree-node:after {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  .el-tree-node:before {
    border-left: 1px solid #d8dae1;
    bottom: 0px;
    height: 100%;
    top: -17px;
    width: 1px;
  }

  .el-tree-node:after {
    border-top: 1px solid #d8dae1;
    height: 20px;
    top: 21px;
    width: 24px;
  }

  .el-tree .is-current:after {
    background-color: transparent;
  }
}

.edut {
  margin-left: 40px;

  .fontName {
    font-size: 12px;
    font-weight: bold;
    color: rgba(84, 85, 102, 1);
    margin-bottom: 20px;
  }
}







.el-form-item:first-child {
  margin-top: 22px;
}

.module_left_line {
  font-size: 12px;
  margin-left: 25px;
  border-left: 1px solid #d9dbe2;
  font-weight: bold;
}

.module_left {
  margin-left: 20px;
  display: inline-flex;
  margin-top: 20px;
  position: relative;
}

.module_name {
  width: 90px;
  position: relative;
}

.module_line {
  position: absolute;
  border: 0.5px solid #d9dbe2;
  width: 15px;
  left: -20px;
  top: 8px;
}

.child_moudle_left_line {
  border-left: 1px solid #d9dbe2;
  margin-left: 29px;
  display: flex;
  flex-direction: column;
}

.child_moudle_left {
  display: inline-flex;
  margin-left: 15px;
  margin-top: 20px;
  position: relative;
}

.child_moudle_name {
  width: 52px;
  position: relative;
}

.child_module_line {
  position: absolute;
  border: 0.5px solid #d9dbe2;
  width: 15px;
  left: -15px;
  top: 8px;
}

.module_last_cover {
  width: 10px;
  height: 10000px;
  display: block;
  position: absolute;
  left: -30px;
  top: 9px;
  background: white;
}

.child_module_last_cover {
  display: block;
  height: 10000px;
  width: 10px;
  position: absolute;
  left: -20px;
  top: 9px;
  background: white;
}

.ssg_title {
  padding-left: 20px;
  margin-bottom: 10px;

  span {
    font-size: 12px;
    font-weight: bold;
    color: rgba(84, 85, 102, 1);
  }
}

.ssg_title span {
  margin-right: 66px;
}

.el-checkbox__label {
  font-size: 12px;
  font-weight: bold;
}

.el-checkbox-group {
  display: contents;
}

.el-checkbox-group label {
  /* margin-left: 10px; */
  margin-right: 15px;
  width: 120px;
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #6669e3;
  border-color: #6669e3;
}

.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266;
}

.el-icon-arrow-right:before {
  content: "\E604";
  color: white;
}

.el-collapse {
  border: 0;
}

.el-collapse-item__header {
  color: #6669e3;
  font-weight: bold;
  padding-left: 20px;
  border: 0;
  position: relative;
}

.el-carousel__mask,
.el-cascader-menu,
.el-cascader-menu__item.is-disabled:hover,
.el-collapse-item__header {
  background-color: rgb(248, 250, 251);
}

.el-carousel__mask,
.el-cascader-menu,
.el-cascader-menu__item.is-disabled:hover,
.el-collapse-item__header,
.el-collapse-item__wrap {
  background-color: whtie;
}

.el-collapse-item {
  margin-bottom: 15px;
}

.el-collapse-item.is-active {
  border: 1px solid #b2b5ef;
}

.el-collapse-item:last-child {
  margin-bottom: 10px;
}

.el-switch__label--left {
  margin-right: 0;
}

.el-switch__label--right {
  margin-left: 0;
}

.el-switch__label.is-active {
  color: #fff;
}

.el-switch__label {
  color: #fff;
}

.el-switch__core {
  height: 25px;
  border-radius: 15px;
}

.el-switch {
  line-height: 25px;
  height: 25px;
}

.el-switch__label {
  position: absolute;
  /*left: 20%;*/
  /*margin-left: -18px;*/
  height: 25px;
}

.el-switch__label.is-active {
  left: 20%;
}

.el-switch__label--right {
  left: 40%;
}

.el-switch__core:after {
  width: 21px;
  height: 21px;
}

.el-switch.is-checked .el-switch__core::after {
  margin-left: -23px;
}

.el-switch__label * {
  font-size: 12px;
}

// 	.custombtn {
// 		position: absolute;
// 		top: 10px;
// 		right: 10px;
// 	}

.dataitems {
  width: 55%;
  // margin: 0 auto;
  // padding-left: 12%;
  .title {
    font-size: 24px;
    font-weight: bold;
    color: rgba(48, 49, 64, 1);
    text-align: center;
  }
}

.group {
  margin-bottom: 20px;
  background-color: #f2f5f8;
  padding-top: 10px;
  padding-bottom: 20px;
  border-radius: 10px;
  width: 70%;
  margin-left: 15%;
}

.menu {
  margin-bottom: 10px;
  border-bottom: 1px solid #dadee2;
  padding-left: 20px;
  padding-bottom: 10px;
}
.customize {
  width: 100%;
  margin-bottom: 20px;
  .item {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding-left: 100px;
    box-sizing: border-box;
    .title {
      min-width: 100px;
      font-size: 14px;
    }

    .btn {
      min-width: 120px;
      padding: 0 8px;
    }

    .statistics {
      font-size: 14px;
      color: #6668e3;
      margin-left: 20px;
    }
  }
  .blockdiv {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    span {
      font-size: 14px;
      margin: 0 10px 0 16px;
    }
    div {
      padding: 2px 8px;
      background-color: rgb(136, 136, 136);
      font-size: 12px;
      margin-right: 8px;
      border-radius: 4px;
      color: #fff;
      margin-top: 10px;
      i {
        cursor: pointer;
      }
    }
  }
}
.header {
  height: 63px;
  background-color: #f2f5f8;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;

  .left {
    display: flex;
    align-items: center;
  }
  .company {
    font-size: 14px;
    font-weight: 400;
    color: rgba(48, 49, 64, 1);
    margin-right: 30px;
  }
  .line {
    width: 1px;
    height: 21px;
    background-color: #d9dbe2;
    margin: 0 37px;
  }
  .back {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    cursor: pointer;
  }
  .logo {
    margin-left: 30px;
    
  }
}
.box {
  display: flex;
  margin-top: 20px;

  .return {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    margin-right: 20px;
    cursor: pointer;
  }

  .line {
    margin-right: 20px;
    color: #606266;
  }

  .lines {
    margin-right: 20px;
    color: #606266;
    font-weight: bold;
  }

  .back:hover {
    color: #6669e3;
    cursor: pointer;
  }

  .contract {
    margin-right: 20px;

    font-size: 12px;
    font-weight: 400;
    color: rgba(138, 138, 154, 1);
  }
}
</style>
